import {
  OPEN_WEBSOCKET,
  OPEN_WEBSOCKET_LOGIN,
  SEND_MESSAGE,
  CLOSE_WEBSOCKET,
} from "./actionTypes";

export const closeWebsocket = () => ({
  type: CLOSE_WEBSOCKET,
});

export const sendMessage = (message) => ({
  type: SEND_MESSAGE,
  message: message,
});

export const openWebsocket = (token, apiLocation) => ({
  type: OPEN_WEBSOCKET,
  token: token,
  apiLocation: apiLocation,
});

export const openWebsocketLogin = (login, apiLocation) => ({
  type: OPEN_WEBSOCKET_LOGIN,
  login: login,
  apiLocation: apiLocation,
});
